import React from "react";

export const StaticItems = () => (
    <React.Fragment>
        <section className="dienste">
            <span className="navdi">Dienste</span>
            <a href="https://email.t-online.de" target="_blank" rel="noopener noreferrer" data-ga-label="e-mail">
                E-Mail
            </a>
            <a
                href="https://www.t-online.de/wetter/id_69501032/smartphone-wetter.html"
                className="wetter"
                data-ga-label="wetter"
            >
                <span></span>Wetter
            </a>
            <a href="https://www.t-online.de/sport/live-ticker/" className="hideDesktop" data-ga-label="liveticker">
                Liveticker
            </a>
            <a href="https://www.t-online.de/sport/live-ticker/#table" data-ga-label="ergebnisse & tabellen">
                Ergebnisse & Tabellen
            </a>

            <a
                href="https://sportwetten.t-online.de/"
                data-ga-label="sportwetten"
                target="_blank"
                rel="noopener noreferrer"
            >
                Sportwetten
            </a>

            <a
                href="https://www.lotto24.de/?partnerId=1DECOO0536&amp;advertisementId=1MOBWEBNAVIGATIO000000000000000000000000000&amp;campaignId=tonline_gws"
                rel="nofollow"
                data-ga-label="lotto"
            >
                Lotto spielen (ANZEIGE)
            </a>

            <a href="https://www.t-online.de/-/id_70041880/index" data-ga-label="telefonverzeichnisse">
                Telefonverzeichnisse
            </a>

            <a href="https://www.t-online.de/finanzen/boerse/" data-ga-label="börse">
                Börse
            </a>
            <a href="https://jobsuche.t-online.de/" target="_blank" rel="noopener noreferrer" data-ga-label="jobsuche">
                Jobsuche (ANZEIGE)
            </a>
            <a href="https://gebrauchtwagen-suche.t-online.de/" data-ga-label="automarkt">
                Automarkt (ANZEIGE)
            </a>
        </section>
        <section className="empfehlungen">
            <span className="navdi">Empfehlungen</span>
            <a
                href="https://cloud.telekom-dienste.de/"
                target="_blank"
                rel="noopener noreferrer"
                data-ga-label="magentaCloud"
            >
                MagentaCloud
            </a>
            <a
                href="http://www.telekom.de/kundencenter"
                target="_blank"
                rel="noopener noreferrer"
                data-ga-label="kundencenter"
            >
                Kundencenter
            </a>
            <a href="https://tarife-und-produkte.t-online.de/" data-ga-label="tarife & produkte">
                Tarife & Produkte
            </a>
        </section>

        <section className="allgemeines">
            <span className="navdi">Allgemeines</span>
            <a href="https://www.t-online.de/impressum/id_12511434/index" data-ga-label="impressum">
                Impressum
            </a>
        </section>
    </React.Fragment>
);
